/*
 * SOLBELI — Sincronización geométrica del desplegable Rapid Search.
 * Código nuevo, independiente de Shrine y de Rapid Search.
 * Alinea solo eje horizontal/ancho; la aplicación conserva top, visibilidad y contenido.
 */
(function () {
  'use strict';

  var PANEL_ID = 'rapid-search-results';
  var FIELD_SELECTOR = '.solbeli-dawn-inline-search .solbeli-dawn-search__form';
  var rafId = 0;
  var observedPanel = null;
  var panelObserver = new MutationObserver(scheduleUpdate);
  var insertionObserver = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.id === PANEL_ID || (node.querySelector && node.querySelector('#' + PANEL_ID))) {
          scheduleUpdate();
          return;
        }
      }
    }
  });

  function observePanel(panel) {
    if (observedPanel === panel) return;
    panelObserver.disconnect();
    observedPanel = panel;
    if (panel) {
      panelObserver.observe(panel, { attributes: true, attributeFilter: ['style'] });
    }
  }

  function setImportant(style, property, value) {
    if (style.getPropertyValue(property) !== value ||
        style.getPropertyPriority(property) !== 'important') {
      style.setProperty(property, value, 'important');
    }
  }

  function update() {
    rafId = 0;

    var field = document.querySelector(FIELD_SELECTOR);
    var panel = document.getElementById(PANEL_ID);
    observePanel(panel);
    if (!field || !panel) return;

    var rect = field.getBoundingClientRect();
    if (!rect.width) return;

    // Usamos píxeles medidos, no dimensiones fijas: ResizeObserver y resize
    // mantienen el mismo ancho y alineación en escritorio, tablet y móvil.
    setImportant(panel.style, 'left', rect.left.toFixed(2) + 'px');
    setImportant(panel.style, 'width', rect.width.toFixed(2) + 'px');
    setImportant(panel.style, 'right', 'auto');
    setImportant(panel.style, 'transform', 'none');
    setImportant(panel.style, 'max-width', 'none');
    setImportant(panel.style, 'box-sizing', 'border-box');
  }

  function scheduleUpdate() {
    if (!rafId) rafId = window.requestAnimationFrame(update);
  }

  function init() {
    var field = document.querySelector(FIELD_SELECTOR);
    if (!field) return;

    if ('ResizeObserver' in window) {
      new ResizeObserver(scheduleUpdate).observe(field);
    }

    // Rapid Search inserta su contenedor dinámicamente fuera del buscador.
    insertionObserver.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    field.addEventListener('focusin', scheduleUpdate);
    field.addEventListener('input', scheduleUpdate);
    scheduleUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
